import { decodeHTML, isHtmlContent } from '../../helpers/decodeHTML';
import LinkRenderer from '../../ui/LinkRenderer';

export default function RichTextPreview({ html, descriptionLinkPayload }) {
    const isHTML = isHtmlContent(decodeHTML(html));
    const htmlString = isHTML ? decodeHTML(html) : html;
    return (
        <div
            className="prose text-xs max-w-none [&_p:empty]:before:content-['\00a0'] [&_p:empty]:inline-block"
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
}
